const levels = [
  {
    icon: 'ri-user-line',
    title: 'Личная эффективность руководителя',
    items: 'принятие решений, управление состоянием, приоритеты',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Управление сотрудником',
    items: 'постановка задач, делегирование, контроль, обратная связь',
  },
  {
    icon: 'ri-team-line',
    title: 'Управление командой',
    items: 'мотивация, коммуникация, конфликты, взаимодействие',
  },
  {
    icon: 'ri-arrow-left-right-line',
    title: 'Управление изменениями',
    items: 'внедрение новых процессов, работа с сопротивлением',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Управление результатом',
    items: 'цели, ответственность, показатели, развитие самостоятельности команды',
  },
];

export default function CompetencyMatrix() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Управленческие компетенции: от базовых навыков к системному управлению
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Компетенции руководителя выстраиваются в логическую систему — от личной эффективности до управления результатом бизнеса
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute left-[23px] top-8 bottom-8 w-0.5 bg-teal-200"></div>
          <div className="space-y-5">
            {levels.map((level, i) => (
              <div key={level.title} className="flex gap-5 items-start relative">
                <div className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center text-lg flex-shrink-0 z-10">
                  <i className={`${level.icon} text-xl`}></i>
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 flex-1 hover:border-teal-300 transition-colors">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">
                    <span className="text-teal-600 mr-1.5">{i + 1}.</span>
                    {level.title}
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{level.items}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}